export const SET_IP_PAGE = 'SET_IP_PAGE';
export const SET_ALLOWED_IP_LIST = 'SET_ALLOWED_IP_LIST';
export const ALLOWED_IP_LIST_REQUEST = 'IP_BLOCK_LIST_REQUEST';
export const ALLOWED_IP_REMOVE = 'IP_BLOCK_REMOVE';
export const ALLOWED_IP_CREATE = 'IP_BLOCK_LOCKED_STATE_UPDATE';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
